export default __webpack_public_path__ + "db4f9f6b50f3da93c6edfaeb10eb875b.png";